<template>
  <div class="dashboard-home">

    <div class="dashboard-hero">
      <div class="container-fluid">
        <div class="hero-inner">
          <div>
            <h1 class="hero-title">لوحة التحكم</h1>
            <p class="hero-subtitle">إدارة الطلاب والمحتوى التعليمي</p>
          </div>
          <div class="hero-badge">
            <i class="pi pi-shield"></i>
            <span>بوابة الإدارة</span>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid py-4" style="padding-left:1.5rem; padding-right:1.5rem;">


      <div v-if="followUpAccess.can('follow-ups.view') || followUpAccess.can('follow-ups.create') || followUpAccess.can('follow-up-types.view')" class="row g-4 mb-4" dir="rtl" data-testid="follow-up-dashboard">
        <div class="col-xl-4 col-lg-6 col-12">
          <div class="module-card module-card--teal">
            <div class="module-card__header">
              <div class="module-card__icon-wrap"><i class="pi pi-list-check"></i></div>
              <h3 class="module-card__title">المتابعة الدورية</h3>
            </div>
            <div class="module-card__body">
              <router-link v-if="followUpAccess.can('follow-ups.view') || followUpAccess.can('follow-ups.create')" to="/follow-ups" class="module-link"><i class="pi pi-list"></i><span>المتابعة الدورية</span></router-link>
              <router-link v-if="followUpAccess.can('follow-up-types.view')" to="/follow-up-types" class="module-link"><i class="pi pi-tags"></i><span>أنواع المتابعات</span></router-link>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="text-center py-5">
        <i class="pi pi-spin pi-spinner" style="font-size:2rem;"></i>
      </div>

      <template v-else>

        <div v-if="activeGrades.length === 0" class="text-center py-5">
          <i class="pi pi-info-circle" style="font-size:2.5rem; color:#94a3b8;"></i>
          <p class="mt-3 text-muted">لا توجد سنوات دراسية مفعّلة حالياً.</p>
          <router-link to="/academic-years" class="btn PrimaryButton mt-2">
            <i class="pi pi-cog me-1"></i> إعداد السنوات الدراسية
          </router-link>
        </div>

        <template v-else>

          <!-- Primary -->
          <template v-if="gradesByStage.primary.length">
            <div class="section-header mb-3">
              <span class="section-label">المرحلة الابتدائية</span>
              <div class="section-divider"></div>
            </div>
            <div class="row g-4 mb-5">
              <div v-for="(grade, i) in gradesByStage.primary" :key="grade.id" class="col-xl-3 col-lg-6 col-md-6 col-12">
                <GradeCard :grade="grade" :color="cardColor(i)" :gradeRoute="gradeRoute" @link-click="onGradeCardClick(grade)" />
              </div>
            </div>
          </template>

          <!-- Prep -->
          <template v-if="gradesByStage.prep.length">
            <div class="section-header mb-3">
              <span class="section-label">المرحلة الإعدادية</span>
              <div class="section-divider"></div>
            </div>
            <div class="row g-4 mb-5">
              <div v-for="(grade, i) in gradesByStage.prep" :key="grade.id" class="col-xl-3 col-lg-6 col-md-6 col-12">
                <GradeCard :grade="grade" :color="cardColor(i + 2)" :gradeRoute="gradeRoute" @link-click="onGradeCardClick(grade)" />
              </div>
            </div>
          </template>

          <!-- Secondary -->
          <template v-if="gradesByStage.secondary.length">
            <div class="section-header mb-3">
              <span class="section-label">المرحلة الثانوية</span>
              <div class="section-divider"></div>
            </div>
            <div class="row g-4 mb-5">
              <div v-for="(grade, i) in gradesByStage.secondary" :key="grade.id" class="col-xl-3 col-lg-6 col-md-6 col-12">
                <GradeCard :grade="grade" :color="cardColor(i)" :gradeRoute="gradeRoute" @link-click="onGradeCardClick(grade)" />
              </div>
            </div>
          </template>

        </template>

        <!-- Admin Section -->
        <div class="section-header mb-3">
          <span class="section-label">الإدارة</span>
          <div class="section-divider"></div>
        </div>

        <div class="row g-4 align-items-start">
          <div class="col-xl-3 col-lg-6 col-md-6 col-12">
            <div class="module-card module-card--indigo">
              <div class="module-card__header">
                <div class="module-card__icon-wrap"><i class="pi pi-globe"></i></div>
                <h3 class="module-card__title">الموقع الإلكتروني</h3>
              </div>
              <div class="module-card__body">
                <router-link to="/website_text" class="module-link">
                  <i class="pi pi-align-right"></i><span>نصوص الموقع</span>
                </router-link>
                <router-link to="/whatsapp_links" class="module-link">
                  <i class="pi pi-comments"></i><span>لينكات واتساب</span>
                </router-link>
                <router-link to="/whatsapp_groups" class="module-link">
                  <i class="pi pi-users"></i><span>مجموعات واتساب</span>
                </router-link>
                <router-link to="/website_time" class="module-link">
                  <i class="pi pi-clock"></i><span>بداية الحجز</span>
                </router-link>
                <router-link to="/web_status" class="module-link">
                  <i class="pi pi-power-off"></i><span>حالة الحجز</span>
                </router-link>
              </div>
              <div class="module-card__footer">
                <div></div>
                <router-link to="/web_status" class="module-card__cta">
                  <span>إدارة الموقع</span>
                  <i class="pi pi-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-xl-3 col-lg-6 col-md-6 col-12">
            <div class="module-card module-card--teal">
              <div class="module-card__header">
                <div class="module-card__icon-wrap"><i class="pi pi-cog"></i></div>
                <h3 class="module-card__title">إعداد</h3>
              </div>
              <div class="module-card__body">
                <router-link to="/all_student" class="module-link">
                  <i class="pi pi-database"></i>
                  <span>عرض جميع الطلاب</span>
                </router-link>
                <router-link to="/academic-years" class="module-link">
                  <i class="pi pi-sliders-h"></i>
                  <span>تفعيل / تعطيل المراحل</span>
                </router-link>
                <router-link to="/financial-settings" class="module-link">
                  <i class="pi pi-wallet"></i>
                  <span>إدارة البنود المالية</span>
                </router-link>
              </div>
              <div class="module-card__footer">
                <div></div>
                <router-link to="/academic-years" class="module-card__cta">
                  <span>إدارة المراحل</span>
                  <i class="pi pi-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>

          <!-- الرسائل -->
          <div class="col-xl-3 col-lg-6 col-md-6 col-12">
            <div class="module-card module-card--green">
              <div class="module-card__header">
                <div class="module-card__icon-wrap"><i class="pi pi-comments"></i></div>
                <h3 class="module-card__title">الرسائل</h3>
              </div>
              <div class="module-card__body">
                <div v-if="loadingTemplates" class="py-2 text-center">
                  <i class="pi pi-spin pi-spinner" style="color:var(--gold)"></i>
                </div>
                <router-link
                  v-for="tpl in sortedTemplates"
                  :key="tpl.id"
                  :to="templatePath(tpl.code)"
                  class="module-link"
                >
                  <i class="pi" :class="templateIcon(tpl.code)"></i>
                  <span>{{ tpl.name }}</span>
                  <span v-if="!tpl.is_active" class="module-link-badge module-link-badge--off">معطّل</span>
                </router-link>
              </div>
              <div class="module-card__footer">
                <div></div>
                <router-link to="/messages" class="module-card__cta">
                  <span>إدارة الرسائل</span>
                  <i class="pi pi-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>

        </div>

      </template>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useGradeStore } from '@/stores/useGradeStore.js';
import GradeCard from '@/components/grades/GradeCard.vue';
import { useFollowUpAccessStore } from '@/stores/useFollowUpAccessStore';

const COLORS = [
  'module-card--blue',
  'module-card--green',
  'module-card--purple',
  'module-card--amber',
  'module-card--indigo',
  'module-card--slate',
  'module-card--rose',
  'module-card--teal',
];

const TEMPLATE_ICON_MAP = {
  absence_notification:      'pi-calendar-times',
  absence_notification_bulk: 'pi-users',
  payment_reminder:          'pi-bell',
  payment_confirmation:      'pi-check-circle',
  payment_reminder_bulk:     'pi-bell',
  reservation_notification:  'pi-bookmark',
  attendance_confirmation:   'pi-check',
};

const TEMPLATE_SLUG_MAP = {
  payment_confirmation:      '/messages/payment-confirmation',
  payment_reminder:          '/messages/payment-reminder',
  payment_reminder_bulk:     '/messages/payment-reminder',
  absence_notification:      '/messages/absence',
  absence_notification_bulk: '/messages/absence-bulk',
  reservation_notification:  '/messages/reservation',
  attendance_confirmation:   '/messages/attendance-confirmation',
};

const TEMPLATE_SORT = {
  payment_confirmation:      1,
  payment_reminder:          2,
  payment_reminder_bulk:     3,
  absence_notification:      4,
  absence_notification_bulk: 5,
  reservation_notification:  6,
  attendance_confirmation:   7,
};

export default {
  name: 'dashboard-home',
  components: { GradeCard },

  data() {
    return {
      whatsappTemplates: [],
      loadingTemplates:  true,
    };
  },

  computed: {
    followUpAccess() { return useFollowUpAccessStore(); },
    gradeStore() { return useGradeStore(); },
    activeGrades() { return this.gradeStore.activeGrades; },
    loading() { return this.gradeStore.loading; },
    gradesByStage() { return this.gradeStore.activeGradesByStage; },
    sortedTemplates() {
      return [...this.whatsappTemplates].sort((a, b) => {
        const oa = TEMPLATE_SORT[a.code] ?? 99;
        const ob = TEMPLATE_SORT[b.code] ?? 99;
        return oa - ob;
      });
    },
  },

  methods: {
    cardColor(i) {
      return COLORS[i % COLORS.length];
    },
    gradeRoute(grade, module) {
      const s = grade.slug;
      const routes = {
        students:   `/grades/${s}/students`,
        add:        `/grades/${s}/students/add`,
        absence:    `/grades/${s}/absence`,
        attendance: `/grades/${s}/attendance`,
        payments:   `/grades/${s}/payments`,
        groups:     `/grades/${s}/groups`,
        branch:     `/branch/${s}`,
        unit:       `/unit/${s}`,
        lesson:     `/lesson/${s}`,
        content:    `/${s}/content`,
        questions:  `/${s}/questions`,
        exams:      `/${s}/exams`,
      };
      return routes[module] ?? '/';
    },
    onGradeCardClick(grade) {
      this.gradeStore.setCurrentGrade(grade);
    },
    templateIcon(code) {
      return TEMPLATE_ICON_MAP[code] ?? 'pi-envelope';
    },
    templatePath(code) {
      return TEMPLATE_SLUG_MAP[code] ?? '/messages';
    },
    async loadTemplates() {
      this.loadingTemplates = true;
      try {
        const res = await axios.get('/whatsapp-templates');
        this.whatsappTemplates = res.data.data ?? [];
      } catch { /* non-fatal — dashboard still works */ } finally {
        this.loadingTemplates = false;
      }
    },
  },

  async mounted() {
    this.followUpAccess.fetch().catch(() => {});
    await this.gradeStore.fetchActiveGrades();
    this.gradeStore.restoreCurrentGrade();
    this.loadTemplates();
  },
};
</script>

<style scoped>
</style>
